module.exports = __webpack_public_path__ + "static/media/USDT-BUSD.0d24b045.png";